"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var counto_directive_1 = require("./counto.directive");
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./counto.directive');
var CountoModule = /** @class */ (function () {
    function CountoModule() {
    }
    /** @nocollapse */
    CountoModule.ctorParameters = function () { return []; };
CountoModule.ɵfac = function CountoModule_Factory(t) { return new (t || CountoModule)(); };
CountoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CountoModule });
CountoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountoModule, [{
        type: core_1.NgModule,
        args: [{
                declarations: [counto_directive_1.CountoDirective],
                exports: [counto_directive_1.CountoDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CountoModule, { declarations: [ɵngcc1.CountoDirective], exports: [ɵngcc1.CountoDirective] }); })();
    return CountoModule;
}());
exports.CountoModule = CountoModule;

